import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import Widget from '../components/Widget/Widget';
import Login from '../pages/login';
const Router = () => {
  const router = createBrowserRouter([
    { path: '/', element: <Widget /> },
    {path: '/login', element: <Login />}
  ]);

  return <RouterProvider router={router} />;
};

export default Router;
